const state = {
  parceiro: '',
  clientes: ''
}

const getters = {
  parceiro: state => {
    return state.parceiro
  },
  parceiroClientes: state => {
    return state.clientes
  }
}

const mutations = {
  setParceiro (state, value) {
    state.parceiro = value
  },
  setParceiroClientes (state, value) {
    state.clientes = value
  },
}

const actions = {
  setParceiro (context, value) {
    context.commit('setParceiro', value)
  },
  setParceiroClientes (context, value) {
    context.commit('setParceiroClientes', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/parceiro.js